import { render } from "./YandexMapComponent.vue?vue&type=template&id=6e28a53e"
import script from "./YandexMapComponent.vue?vue&type=script&lang=js"
export * from "./YandexMapComponent.vue?vue&type=script&lang=js"

import "./YandexMapComponent.vue?vue&type=style&index=0&id=6e28a53e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__